import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

export type CalendarProvider = 'google' | 'outlook' | 'apple';

export interface CalendarProviderState {
  provider: CalendarProvider;
  connected: boolean;
  syncEnabled: boolean;
  lastSyncedOn?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class CalendarIntegrationService {
  private readonly baseUrl = `${environment.apiUrl}api/CalendarIntegration`;

  constructor(private http: HttpClient) { }

  public getProviderStates(): Observable<CalendarProviderState[]> {
    return this.http.get<CalendarProviderState[]>(`${this.baseUrl}/Status`);
  }

  public startOAuth(provider: CalendarProvider): Observable<{ authorizationUrl: string }> {
    return this.http.post<{ authorizationUrl: string }>(`${this.baseUrl}/${provider}/OAuth/Start`, {});
  }

  public completeOAuth(provider: CalendarProvider, payload: { code: string; state?: string; }): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${provider}/OAuth/Complete`, payload);
  }

  public toggleSync(provider: CalendarProvider, enabled: boolean): Observable<CalendarProviderState> {
    return this.http.post<CalendarProviderState>(`${this.baseUrl}/${provider}/Sync`, { enabled });
  }

  public runOnDemandSync(provider: CalendarProvider): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${provider}/Sync/Run`, {});
  }

  public getExternalEvents(params: { start: string; end: string; teamMemberId?: number }): Observable<any[]> {
    let httpParams = new HttpParams()
      .set('start', params.start)
      .set('end', params.end);

    if (params.teamMemberId !== undefined && params.teamMemberId !== null) {
      httpParams = httpParams.set('teamMemberId', params.teamMemberId.toString());
    }

    return this.http.get<any[]>(`${this.baseUrl}/Events`, { params: httpParams });
  }
}
